module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_04_stay-3ce6d544b79f2a233124e5fa93ffc451.jpg";